/*=========================================================================================
  File Name: moduleOpportunite.js
  Description: Opportunite Module
  ----------------------------------------------------------------------------------------
  Author: Djezou Eric Martial
==========================================================================================*/


import state from './moduleOpportuniteState.js'
import mutations from './moduleOpportuniteMutations.js'
import actions from './moduleOpportuniteActions.js'
import getters from './moduleOpportuniteGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
